<div class="row business-child-accounts">
    <div class="col-md-12 d-md-flex flex-row justify-content-between">
        <div class="term-name">
            <h5>You have {{businessAccount.childUserAccounts.length}} {{businessAccountTypeNameMapping.childTermName}} accounts</h5>
        </div>
        <div ngbDropdown>
            <button
                type="button"
                class="btn m-0"
                ngbDropdownToggle
            >{{businessAccountTypeNameMapping.childTermName}} Account Menu</button>
            <div
                ngbDropdownMenu
                aria-labelledby="accountMenuDropdown"
            >
                <a
                    ngbDropdownItem
                    class="dropdown-item"
                    [routerLink]="['/account/create-child-account']"
                >Create a new {{businessAccountTypeNameMapping.childTermName}} account</a>
                <a
                    ngbDropdownItem
                    class="dropdown-item"
                    [routerLink]="['/account/adopt-child-account']"
                >Link an existing {{businessAccountTypeNameMapping.childTermName}} account</a>
                <div class="dropdown-divider"></div>
                <a
                    ngbDropdownItem
                    class="dropdown-item"
                    routerLink="{{batchRegistrationLink}}"
                >Register for {{brandName}} - at a test centre</a>
                <p
                    *ngIf="brandId === BrandEnum.CAEL"
                    class="dropdown-item text-muted m-0"
                >* For {{brandName}} Online, please sign in as {{businessAccountTypeNameMapping.childTermName}} Account (Alias)</p>
                <a
                    ngbDropdownItem
                    class="dropdown-item"
                    [routerLink]="['/account/list-client-registrations']"
                >View registered tests</a>
                <div class="dropdown-divider"></div>
                <!-- we no longer offer saft -->
                <!-- <a
                    ngbDropdownItem
                    class="dropdown-item"
                    *ngIf="brandId === BrandEnum.CAEL"
                    [routerLink]="['/batch-registration/sitting-selection-saft']"
                >Register for Pretest</a> -->
                <a
                    ngbDropdownItem
                    class="dropdown-item"
                    [routerLink]="['/product-shopping']"
                >Shop for products</a>
                <a
                    ngbDropdownItem
                    class="dropdown-item"
                    [routerLink]="['/account/configure-notifications']"
                    (click)="configureNotifications(businessAccountTypeNameMapping)"
                >Configure email/mailing preferences</a>
            </div>
        </div>
    </div>
</div>

<div class="row filter-row">
    <div class="col-md-12">
        <br />
        <app-search-child-account
            [businessAccountTypeNameMapping]="businessAccountTypeNameMapping"
            [businessAccount]="businessAccount"
            (aliasSignIn)=aliasSignIn($event)
        ></app-search-child-account>
    </div>
</div>
